module.exports = "../../app/cells/pages/guides/v2_journey_cell.rb";